import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';

import CheckoutCard from '../../CheckoutCard';
import OrderSummary from '../OrderSummary';
import PaymentDetails from '../PaymentDetails';

function EditView({ onPlaceOrder }) {
  return (
    <Stack spacing={2}>
      <OrderSummary />
      <CheckoutCard.Divider />
      <PaymentDetails onPlaceOrder={onPlaceOrder} />
    </Stack>
  );
}

EditView.propTypes = {
  onPlaceOrder: PropTypes.func
};

export default EditView;
